module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-BoldItalic.98ad70b7.ttf";